import { render, staticRenderFns } from "./DiscountCouponList.html?vue&type=template&id=2fd4c87c&scoped=true&"
import script from "./DiscountCouponList.js?vue&type=script&lang=js&"
export * from "./DiscountCouponList.js?vue&type=script&lang=js&"
import style0 from "./DiscountCouponList.scss?vue&type=style&index=0&id=2fd4c87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4c87c",
  null
  
)

export default component.exports